/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Status_FailedInputs */

const tr_geliver_status_failed = /** @type {(inputs: Geliver_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başarısız`)
};

const en_geliver_status_failed = /** @type {(inputs: Geliver_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed`)
};

const de_geliver_status_failed = /** @type {(inputs: Geliver_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlgeschlagen`)
};

const ru_geliver_status_failed = /** @type {(inputs: Geliver_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка`)
};

/**
* | output |
* | --- |
* | "Failed" |
*
* @param {Geliver_Status_FailedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_status_failed = /** @type {((inputs?: Geliver_Status_FailedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Status_FailedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_status_failed(inputs)
	if (locale === "de") return de_geliver_status_failed(inputs)
	if (locale === "ru") return ru_geliver_status_failed(inputs)
	return tr_geliver_status_failed(inputs)
});